import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { PageWrapper } from './elements';
import ProfileInfo from './ProfileSettings/ProfileInfo';
import ProfileDelete from './ProfileSettings/ProfileDelete';
import Language from './ProfileSettings/Language';
import Emails from './ProfileSettings/Emails';
import Password from './ProfileSettings/Password';
import Privacy from './ProfileSettings/Privacy';
import Support from './ProfileSettings/Support';
import ResetPassword from './ResetPassword';
import ForgotPassword from './ForgotPassword';
import Loader from './Loader';
import JoinCampaign from './JoinCampaign';
import Register from './Register';
import RegisterPassword from './RegisterPassword';
import Login from './Login';
import Timeline from './Timeline';
import ConfirmEmail from './ConfirmEmail';
import VerifyConfirmEmail from './VerifyConfirmEmail';
import InvalidLink from './InvalidLink';

const pages = {
  profileInfo: ProfileInfo,
  profileDelete: ProfileDelete,
  profileLanguage: Language,
  profilePreferences: Emails,
  profilePassword: Password,
  profileTerms: Privacy,
  profileSupport: Support,
  register: Register,
  registerPassword: RegisterPassword,
  resetPassword: ResetPassword,
  forgotPassword: ForgotPassword,
  login: Login,
  joinCampaign: JoinCampaign,
  timeline: Timeline,
  confirmEmail: ConfirmEmail,
  verifyConfirmEmail: VerifyConfirmEmail,
  invalidLink: InvalidLink,
};

const deps = {
  page: state.app.page,
};

export function App({
  page,
}: typeof deps & ConnectedProps): React.ReactElement {
  if (page === 'notFound') return <h1>{'404'}</h1>;

  const Page = pages[page] || Loader;

  return (
    <PageWrapper>
      <Page />
    </PageWrapper>
  );
}

export default connect(deps, App);
